/*eslint-disable*/
import React, { useState, useEffect } from "react";
import db from "../../../db"

// reactstrap components
import {
    Container,
    Row,
    Col,
} from "reactstrap";

// core components
import EventCategory from "./EventCategory"
import EventCategoryForm from "./EventCategoryForm"
import Search from "../../SearchForm"
import CustomPagination from "../../CustomPagination"

function EventCategories({ size, categories }) {
    // What is going to be displayed. 
    // Necessary since there is a search and pagination
    const [displayed, setDisplayed] = useState([])

    // The eventCategory that is going to be edited
    // Flow: Edit button in <EventCategories /> is pressed => eventCategory state changes
    // => eventCategory state is passed to <EventForm/> => Necessary states gets set
    // => Input fields are automatically filled
    const [eventCategory, setEventCategory] = useState(null)
    const [flag, setFlag] = useState(false)

    // CAREFUL WHEN DELETING!!!!
    // since deleting a category would necessitate the deletion of all events
    // under that category - which would take too much resources
    // increasing fees in google firebase. 
    const del = (eventCategory) => {
        const remove = async () => {
            // get all events under the category to be deleted
            const toDelete = await db.Events.findByField("category", eventCategory.id)
            // map through the events and delete the images from storage + event document
            toDelete.map(
                async (doc) => {
                    await db.Events.removeEventImages(doc)
                    await db.Events.remove(doc.id)
                }
            )
            // remove category image
            await db.EventCategories.removeOneImage(eventCategory)
            // remove category document
            await db.EventCategories.remove(eventCategory.id)
        }
        remove()
    }
    // Stores the items to be deleted
    const [deleted, setDeleted] = useState([])

    // Search
    const [searchResults, setSearchResults] = useState([])
    const fields = () =>
        // Creates a list of keys based on a category's fields, e.g ["name", "caption", ...]
        // Filters the keys based on their values
        // If the key's value is an object, do not include
        Object.keys(categories[0]).reduce((acc, key) => { return (typeof (categories[0][key]) !== "object") ? acc.concat([{ value: key, label: key }]) : acc }, [])

    // Pagination
    // Refer to Events.js
    const [page, setPage] = useState(1)
    const [itemsPerPage] = useState(15)
    useEffect(() => {
        if (searchResults.length === 0) {
            setDisplayed(categories?.slice((page - 1) * itemsPerPage, page * itemsPerPage))
        }
        else {
            setDisplayed(searchResults?.slice((page - 1) * itemsPerPage, page * itemsPerPage))
        }
    }, [page, searchResults, categories?.length, categories])

    return (
        <>
            <div className="section section-dark" id="edit" style={{ minHeight: "100vh" }}>
                <div className="projects-3 " id="projects-3" style={{ paddingTop: 0, height: "auto" }}>
                    <Container style={{ minWidth: "100%" }}>
                        <Row>
                            <Col className="ml-auto mr-auto text-center" md="8">
                                <div className="space-top" />
                                <h2 className="title">All Event Categories</h2>
                                <EventCategoryForm
                                    selectedCategory={eventCategory}
                                    setSelectedCategory={setEventCategory}
                                    flag={flag}
                                    deleted={deleted}
                                    setDeleted={setDeleted}
                                />
                            </Col>
                        </Row>
                        {
                            categories && categories.length > 0 &&
                            <Row>
                                <Col className="ml-auto mr-auto text-center" lg="8" md="8">
                                    <Search
                                        fields={fields}
                                        setSearchResults={setSearchResults}
                                        searchList={categories}
                                    />
                                </Col>
                            </Row>
                        }
                        <Row>
                            {
                                displayed && displayed.map((category) =>
                                    <EventCategory
                                        {...category}
                                        key={category.id}
                                        size={size}
                                        eventCategory={category}
                                        setEventCategory={setEventCategory}
                                        flag={flag}
                                        setFlag={setFlag}
                                        setDeleted={setDeleted}
                                        del={del}
                                    />
                                )
                            }
                        </Row>
                        <Row>
                            {
                                categories && categories.length > 0 &&
                                <Col className="flex-centered">
                                    <div className="space-top" />
                                    <CustomPagination
                                        array={searchResults.length === 0 ? searchResults : categories}
                                        setPage={setPage}
                                        itemsPerPage={itemsPerPage}
                                    />
                                </Col>
                            }
                        </Row>
                    </Container>
                </div>
            </div>
        </>
    );
}

export default EventCategories;
